<template>
  <div class="workbench-approval">
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="workbench-approval-main">
      <div class="top-title">当前审批进度</div>
      <div class="approval-result-box">
        <div style="width: 180px;display: flex;justify-content: space-between;">
          <div>
            <div style="font-size: 12px;color: #97A8BE;">提交人</div>
            <div>{{workData.sponsorAccountName}}</div>
            <div>{{workData.sponsorDate}}</div>
          </div>
          <div style="border: 1px solid #D7D7D7;height: 28px;margin: 15px 0;"></div>
        </div>

        <div v-for="item in workData.contractApproveChainStatuses">
          <!--审批通过-->
          <div style="display: flex;justify-content: flex-start;align-items: center;margin-left: 60px;" v-if="item.approveStatus === '1' && item.approveResult === '1'">
            <div>
              <i class="iconfont el-icon-damai-shenpitongguo" style="color: #4FB07B;font-size: 20px;"></i>
            </div>
            <div style="margin-left: 5px;">
              <div style="color: #009933">审批通过</div>
              <div style="font-size: 12px;color: #97A8BE;">{{item.approveAccountName}}</div>
              <div style="font-size: 12px;color: #97A8BE;">{{item.approveDate}}</div>
              <div style="font-size: 12px;color: #97A8BE;width: 240px;">审批意见：{{item.memo || '无'}}</div>
            </div>
          </div>

          <!--审批中-->
          <div style="display: flex;justify-content: flex-start;align-items: center;margin-left: 60px;" v-if="item.approveStatus === '0'">
            <div>
              <i class="iconfont el-icon-damai-shenpizhong" style="color: #F9A742;font-size: 20px;"></i>
            </div>
            <div style="margin-left: 5px;">
              <div style="color: #F9A742">审批中</div>
              <div style="font-size: 12px;color: #97A8BE;line-height: 40px;">{{item.approveAccountName}}</div>
            </div>
          </div>

          <!--审批驳回-->
          <div style="display: flex;justify-content: flex-start;align-items: center;margin-left: 60px;" v-if="item.approveStatus === '1' && item.approveResult === '2'">
            <div>
              <i class="iconfont el-icon-damai-shenpibohui" style="color: #D81E06;font-size: 20px;"></i>
            </div>
            <div style="margin-left: 5px;">
              <div style="color: #D81E06">审批驳回</div>
              <div style="font-size: 12px;color: #97A8BE;">{{item.approveAccountName}}</div>
              <div style="font-size: 12px;color: #97A8BE;">{{item.approveDate}}</div>
              <div style="font-size: 12px;color: #97A8BE;width: 240px;">审批意见：{{item.memo || '无'}}</div>
            </div>
          </div>
        </div>

      </div>

      <div class="top-title">审批详情</div>
      <div class="approval-detail-box">
        <el-tabs v-model="activeName">
          <el-tab-pane label="基本信息" name="businessBasicInformation">
            <div class="form-line">
              <div>
                <div class="line-text">住户名称：</div>
                <div class="line-info">{{formData.enterpriseName || '无'}}</div>
              </div>
              <div>
                <div class="line-text">社会机构代码：</div>
                <div class="line-info">{{formData.creditCode || '无'}}</div>
              </div>
              <div>
                <div class="line-text">企业法人：</div>
                <div class="line-info">{{formData.legalPersonName || '无'}}</div>
              </div>
            </div>
            <div class="form-line">
              <div>
                <div class="line-text">注册资本：</div>
                <div class="line-info">{{formData.regCapital || '无'}}</div>
              </div>
              <div>
                <div class="line-text">注册时间：</div>
                <div class="line-info">{{formData.regTime || '无'}}</div>
              </div>
              <div>
                <div class="line-text">所属行业：</div>
                <div class="line-info">{{formData.industrySmall || '无'}}</div>
              </div>
            </div>
            <div class="form-line">
              <div>
                <div class="line-text">入孵行业：</div>
                <div class="line-info">{{formData.industry || '无'}}</div>
              </div>
              <div>
                <div class="line-text">联系人：</div>
                <div class="line-info">{{formData.contactName || '无'}}</div>
              </div>
              <div>
                <div class="line-text">联系人电话：</div>
                <div class="line-info">{{formData.contactPhone || '无'}}</div>
              </div>
            </div>
            <div class="form-line">
              <div style="flex: 1">
                <div class="line-text">注册地址：</div>
                <div class="line-info" style="flex: 1">{{formData.regAddress || '无'}}</div>
              </div>
            </div>
            <div class="form-line">
              <div style="flex: 1;">
                <div class="line-text">企业简介：</div>
                <div class="line-info" style="flex: 1">{{formData.companyProfile || '无'}}</div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="孵化信息" name="businessIncubationInformation">
            <div class="form-line">
              <div>
                <div class="line-text">主营项目：</div>
                <div class="line-info">{{formData.mainProject || '无'}}</div>
              </div>
            </div>
            <div class="form-line">
              <div>
                <div class="line-text">孵化期限：</div>
                <div class="line-info">{{formData.hatchTerm || '无'}}</div>
              </div>
              <div>
                <div class="line-text">孵化时间：</div>
                <div class="line-info">{{formData.inStartTime}}至{{formData.inEndTime}}</div>
              </div>
            </div>
            <div class="form-line">
              <div>
                <div class="line-text">孵化专员：</div>
                <div class="line-info">{{formData.hatchExpertName || '无'}}</div>
              </div>
              <div>
                <div class="line-text">创业导师：</div>
                <div class="line-info">{{formData.teacherName || '无'}}</div>
              </div>
            </div>
            <div class="form-line">
              <div>
                <div class="line-text">签订人：</div>
                <div class="line-info">{{formData.signedName || '无'}}</div>
              </div>
              <div>
                <div class="line-text">签订人手机：</div>
                <div class="line-info">{{formData.signedPhone || '无'}}</div>
              </div>
            </div>
            <div class="form-line">
              <div style="flex: 1">
                <div class="line-text">备注：</div>
                <div class="line-info">{{formData.remarks || '无'}}</div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>


      <div class="operationBox">
<!--        <button-cancel value="撤回" v-if="workType === 'sponsored' && workData.contractApproveChainStatuses[workData.contractApproveChainStatuses.length -1].approveStatus === '0'" @cancel="recallContract" />-->
        <el-button size="small" class="btn-confirm" v-if="workType === 'hatchPendingApproval'" @click="confirmApprove()">同意</el-button>
        <el-button size="small" class="reject-button" v-if="workType === 'hatchPendingApproval'" @click="rejectApprove()" >驳回</el-button>
        <button-cancel value="返回" @cancel="toWorkbenchApprovalPage" />
      </div>
    </div>

    <div class="approveDialogBox">
      <el-dialog title="审批意见" :visible.sync="approveDialog">
        <div class="approveMainBox">
          <div class="approveFlexBox">
            <div class="approve_title">审批意见</div>
            <el-input type="textarea" :rows="4" placeholder="审批意见" v-model="memo" style="width: 300px;" size="mini" />
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancelApprove">取 消</el-button>
          <el-button size="small" type="primary" @click="passSubmit">确 定</el-button>
        </div>
      </el-dialog>
    </div>

    <div class="approveDialogBox">
      <el-dialog title="审批意见" :visible.sync="approveRejectDialog">
        <div class="approveMainBox">
          <div class="approveFlexBox">
            <div class="approve_title">审批意见</div>
            <el-input type="textarea" :rows="4" placeholder="审批意见" v-model="rejectMemo" style="width: 300px;" size="mini" />
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancelReject">取 消</el-button>
          <el-button size="small" type="primary" @click="unpassSubmit">确 定</el-button>
        </div>
      </el-dialog>
    </div>

    <div class="approveDialogBox">
      <el-dialog title="合同加签" :visible.sync="submitAgainDialog">
        <div class="approveMainBox">
          <div class="approveFlexBox">
            <div class="approve_title">
              <b class="red">*</b>
              <span>审批人</span>
            </div>
            <el-select v-model="approveAccountCode" placeholder="请选择" size="mini" style="width: 300px">
              <el-option
                v-for="item in accountList"
                :key="item.code"
                :label="item._labelName"
                :value="item.code">
              </el-option>
            </el-select>
          </div>
          <div class="approveFlexBox">
            <div class="approve_title">
              <b class="red"></b>
              <span>加签备注</span>
            </div>
            <el-input type="textarea" :rows="4" placeholder="请输入备注" v-model="additionalSignatureMemo" style="width: 300px;" size="mini" />
          </div>
        </div>

        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancelAdditionalSignature">取 消</el-button>
          <el-button size="small" type="primary" @click="confirmAdditionalSignature">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  import Breadcrumb from '../../components/Breadcrumb/Breadcrumb'
  import ButtonCancel from '../../components/Button/ButtonCancel'
  import ButtonAdd from '../../components/common/buttons/button-add'
  import {errorHandler} from '../../utils/errorHandler'
  import {api} from '../api/WorkbenchApproval'
  import ButtonConfirm from '../../components/Button/ButtonConfirm'
  import {nError, nSuccess} from '../../utils/notice'
  import {bus} from '../../utils/bus'

  export default {
    components: {
      ButtonConfirm,
      ButtonAdd,
      ButtonCancel,
      Breadcrumb},
    name: 'approval-detail',
    data () {
      return {
        breadcrumb: [{
          value: '工作台',
          name: 'workbench'
        }, {
          value: '审批详情'
        }],
        approveDialog: false,
        approveRejectDialog: false,
        submitAgainDialog: false,
        workData: {},
        workType: '', // sponsored-我发起的  pendingApproval-待我审批  approved-我已审批
        activeName: 'businessBasicInformation',
        accountCode: '',
        accountName: '',
        accountList: [],

        formData: {},
        memo: '',
        rejectMemo: '',
        approveAccountCode: '',
        additionalSignatureMemo: '',

      }
    },
    created () {
      // this.workData = this.$route.query.workData
      // this.workType = this.$route.query.workType
      this.workData = jQuery.parseJSON(sessionStorage.getItem('hatchWorkDetailData'))
      this.workType = sessionStorage.getItem('hatchWorkDetailActiveName')
      this.accountCode = bus.global.accountCode
      this.accountName = bus.global.accountName
      this.getHatchProtocolByCode()
      this.getAccountListByCode()
    },
    methods: {
      // 跳转我的工作台
      toWorkbenchApprovalPage () {
        this.$router.back(-1)
      },
      // 获取审批人员列表
      getAccountListByCode () {
        this.$axios.post(api.getHatchAccountListByCode, {
          accountCode: this.accountCode
        })
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data
              if (data.length > 0) {
                data.map(v => {
                  v._labelName = `${v.name} / ${v.actualName}`
                })
              }
              this.accountList = data
            }
          })
          .catch(errorHandler('获取审批人员列表失败'))
      },
      // 获取协议信息
      getHatchProtocolByCode () {
        this.$axios.get(`${api.getHatchProtocolByCode}/${this.workData.protocolCode}`, {})
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data
              this.formData = data
            }
          })
          .catch(errorHandler('查询协议失败'))
      },

      // 撤回审批
      recallContract () {
        this.$confirm('是否确认撤回审批？', '提示', {
          type: 'info'
        })
          .then(() => {
            this.$axios.post(api.recallContract, {
              approveType: this.workData.approveType,
              contractCode: this.workData.contractCode
            })
              .then(res => {
                if (res.data.retCode === 1) {
                  nSuccess('审批已撤回')
                  this.toWorkbenchApprovalPage()
                }
              })
              .catch(errorHandler('审批撤回失败'))
          })
          .catch(() => {
            console.log()
          })
      },

      // 审批通过输入意见
      confirmApprove () {
        this.approveDialog = true
      },

      // 审批驳回输入意见
      rejectApprove () {
        this.approveRejectDialog = true
      },

      // 取消审批通过
      cancelApprove () {
        this.memo = ''
        this.approveDialog = false
      },

      // 审批通过
      passSubmit () {
        this.$axios.post(api.protocolApprovePassSubmit, {
          code: this.workData.code,
          memo: this.memo,
          protocolApproveChainStatusCode: this.workData.contractApproveChainStatuses[0].code
        })
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('审批已通过')
              this.memo = ''
              this.toWorkbenchApprovalPage()
            }
          })
          .catch(errorHandler('审批通过失败'))
      },

      // 取消审批驳回
      cancelReject () {
        this.rejectMemo = ''
        this.approveRejectDialog = false
      },

      // 审批驳回
      unpassSubmit () {
        this.$axios.post(api.protocolApproveUnPassSubmit, {
          code: this.workData.code,
          memo: this.rejectMemo,
          protocolApproveChainStatusCode: this.workData.contractApproveChainStatuses[0].code
        })
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('审批已驳回')
              this.rejectMemo = ''
              this.toWorkbenchApprovalPage()
            }
          })
          .catch(errorHandler('审批通过失败'))
      },

      // 取消加签
      cancelAdditionalSignature () {
        this.submitAgainDialog = false
        this.approveAccountCode = ''
      },

      // 确定加签
      confirmAdditionalSignature () {
        if (!this.approveAccountCode) {
          nError('请选择审批人')
          return false
        }
        let dataObj = this.workData.contractApproveChainStatuses[this.workData.contractApproveChainStatuses.length - 1]

        this.accountList.map(v => {
          if (v.code === this.approveAccountCode) {
            dataObj.approveAccountName = v.name
            dataObj.approveAccountCode = v.code
          }
        })
        this.$axios.post(api.submitAgain, dataObj)
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('加签成功')
              this.approveAccountCode = ''
              this.toWorkbenchApprovalPage()
            }
          })
          .catch(errorHandler('加签失败'))
      }
    }
  }
</script>

<style scoped>
  .workbench-approval {
    text-align: left;
  }
  .workbench-approval-main {
    padding: 0 10px;
  }
  .top-title {
    color: #48576A;
    margin: 25px 0 10px 0;
    padding-left: 5px;
    font-size: 16px;
    line-height: 28px;
    border-left: 3px solid #00A0E6;
  }
  .approval-result-box {
    padding: 10px 30px;
    border-radius: 9px;
    color: #48576A;
    border: 1px solid #D7D7D7;
    display: flex;
    line-height: 20px;
    justify-content: flex-start;
  }
  .form-title {
    color: #666666;
    font-size: 14px;
    line-height: 24px;
    padding-left: 5px;
  }
  .form-line {
    margin: 20px 0;
    display: flex;
    justify-content: flex-start;
  }
  .form-line> div {
    display: flex;
    justify-content: flex-start;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
    width: 130px;
    text-align: right;
  }
  .line-info {
    width: 215px;
  }
</style>

<style lang="less">
  .workbench-approval {
    .el-tabs__active-bar {
      width: 96px!important;
    }
    .el-tabs--top {
      height: 100%;
      .is-top:nth-child(2) {
        padding-left: 20px!important;
      }
      #tab-rentTerms {
        /*margin: 0 0 0 20px;*/
      }
      .is-top:last-child {
        padding-left: 0;
        .el-tabs__item {
          padding: 0 20px;
        }
      }
      .el-tabs__nav-wrap::after {
        height: 1px;
      }
    }

    .approval-detail-box {
      padding: 20px 10px;
      .el-tabs__content {
        padding-bottom: 20px;
      }
    }

    .btn-confirm {
      border: 0;
      color: #FFF;
      padding: 8px 16px;
      background-color: #00a0e6;
      border-radius: 4px;
    }
    .btn-confirm:hover {
      color: #FFF;
      background-color: #06b3ff;
    }

    .operationBox {
      display: flex;
      justify-content: flex-end;
      border-radius: 4px;
      .reject-button {
        background-color: #f25721;
        color: #FFFFFF;
      }
      .reject-button:hover {
        background-color: #F96E3D;
      }
    }
  }

  .approveDialogBox {
    text-align: left;
    .el-dialog {
      width: 800px;
    }
    .approveMainBox {
      text-align: center;
    }
    .approve_title {
      width: 120px;
    }
    .approveFlexBox {
      width: 500px;
      margin: 0 auto 20px;
      display: flex;
      justify-content: flex-start;
    }
    .red {
      color: red;
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/Workbench/HatchApprovalDetail.vue